<template>
  <section id="why" class="ec-section why">
    <div class="ec-container">
      <header class="why__head">
        <span class="ec-eyebrow" v-reveal>{{ $t('why.eyebrow') }}</span>
        <h2 class="ec-title" v-reveal="60">{{ $t('why.titlePre') }}<span class="ec-gradient-text">{{ $t('why.titleHi') }}</span></h2>
        <p class="ec-lead" v-reveal="120">{{ $t('why.lead') }}</p>
      </header>

      <div class="why__features">
        <div v-for="(f, i) in features" :key="f.title" class="feat" v-reveal="i * 70">
          <span class="feat__icon">{{ f.icon }}</span>
          <div>
            <h3>{{ f.title }}</h3>
            <p>{{ f.desc }}</p>
          </div>
        </div>
      </div>

      <div ref="stats" class="why__stats" v-reveal>
        <div v-for="(s, i) in stats" :key="i" class="stat">
          <strong>{{ s.prefix }}{{ s.display }}{{ s.suffix }}</strong>
          <span>{{ statLabels[i] }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WhySection',
  data() {
    return {
      counted: false,
      // numeric targets are language-independent; labels come from i18n
      stats: [
        { target: 2000, prefix: '', suffix: '+', display: 0 },
        { target: 5, prefix: '', suffix: '+', display: 0 },
        { target: 5, prefix: '', suffix: '+', display: 0 },
        { target: 20, prefix: '', suffix: '+', display: 0 }
      ]
    }
  },
  computed: {
    features() { return this.$tm('why.features') },
    statLabels() { return this.$tm('why.stats').map((s) => s.label) }
  },
  mounted() {
    if (typeof IntersectionObserver === 'undefined') { this.runCount(); return }
    this._obs = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !this.counted) { this.counted = true; this.runCount(); this._obs.disconnect() }
    }, { threshold: 0.3 })
    if (this.$refs.stats) this._obs.observe(this.$refs.stats)
  },
  beforeUnmount() { if (this._obs) this._obs.disconnect() },
  methods: {
    runCount() {
      const duration = 1600
      const start = performance.now()
      const tick = (now) => {
        const t = Math.min((now - start) / duration, 1)
        const eased = 1 - Math.pow(1 - t, 3)
        this.stats.forEach((s) => {
          const val = s.target * eased
          s.display = s.decimals ? val.toFixed(s.decimals) : Math.round(val).toLocaleString()
        })
        if (t < 1) requestAnimationFrame(tick)
        else this.stats.forEach((s) => { s.display = s.decimals ? s.target.toFixed(s.decimals) : s.target.toLocaleString() })
      }
      requestAnimationFrame(tick)
    }
  }
}
</script>

<style scoped>
.why__head { text-align: center; display: flex; flex-direction: column; align-items: center; margin-bottom: 58px; }

.why__features { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
.feat {
  display: flex; gap: 16px; padding: 26px 24px;
  background: var(--ec-card); border: 1px solid var(--ec-line); border-radius: var(--ec-radius);
  transition: transform .3s ease, border-color .3s ease;
}
.feat:hover { transform: translateY(-4px); border-color: rgba(255,153,0,.35); }
.feat__icon { font-size: 30px; flex: none; }
.feat h3 { font-size: 18px; margin-bottom: 7px; }
.feat p { font-size: 14.5px; color: var(--ec-text-soft); }

.why__stats {
  margin-top: 30px; display: grid; grid-template-columns: repeat(4, 1fr); gap: 1px;
  background: var(--ec-line); border: 1px solid var(--ec-line); border-radius: 22px; overflow: hidden;
}
.stat { background: linear-gradient(165deg, rgba(20,28,56,.6), rgba(10,15,33,.6)); padding: 40px 24px; text-align: center; }
.stat strong { display: block; font-size: clamp(32px, 4vw, 48px); font-weight: 900; background: var(--ec-grad); -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent; }
.stat span { font-size: 14px; color: var(--ec-text-soft); margin-top: 6px; display: block; }

@media (max-width: 900px) { .why__features { grid-template-columns: 1fr; } .why__stats { grid-template-columns: repeat(2, 1fr); } }
</style>
